export default {
  "grapesjs-chartjs-plugin": {
    category: "Charts",
    blocks: {
      bar: "Bar Chart",
      line: "Line Chart",
      pie: "Pie Chart",
      doughnut: "Doughnut Chart",
      polarArea: "Polar Area Chart",
      radar: "Radar Chart",
      bubble: "Bubble Chart",
      scatter: "Scatter Chart",
    },
    traits: {
      addBackgroundColor: "Add Background Color",
      addBorderColor: "Add Border Color",
      addColor: "Add Color",
      addDataset: "Add Dataset",
      addLineColor: "Add Line Color",
      addPointColor: "Add Point Color",
      addSegmentColor: "Add Segment Color",
      borderWidth: "Border Width",
      chartSettings: "Chart Settings",
      dataset: "Dataset",
      datasetData: "Values",
      datasetLabels: "Labels",
      datasetName: "Name",
      height: "Height",
      fill: "Fill",
      lineWidth: "Line Width",
      radius: "Radius",
      removeColor: "Remove Color",
      removeDataset: "Remove Dataset",
      tension: "Tension",
      title: "Title",
      subtitle: "Subtitle",
      width: "Width",
    },
  },
};
